var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Numbers/Number 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0007 6.66667C14.9398 6.66667 13.9224 7.08809 13.1722 7.83824C12.4221 8.58838 12.0007 9.6058 12.0007 10.6667C12.0007 11.403 11.4037 12 10.6673 12C9.93095 12 9.33399 11.403 9.33399 10.6667C9.33399 8.89856 10.0364 7.20286 11.2866 5.95262C12.5369 4.70238 14.2325 4 16.0007 4C17.7688 4 19.4645 4.70238 20.7147 5.95262C21.9649 7.20286 22.6673 8.89856 22.6673 10.6667C22.6673 12.5888 21.6806 14.1239 20.8559 15.2193C20.8551 15.2203 20.8544 15.2212 20.8537 15.2222L13.3229 25.3333H21.334C22.0704 25.3333 22.6673 25.9303 22.6673 26.6667C22.6673 27.403 22.0704 28 21.334 28H10.6673C10.1631 28 9.702 27.7156 9.47575 27.2649C9.2495 26.8143 9.29681 26.2746 9.598 25.8702L18.7236 13.6178C19.4851 12.6067 20.0007 11.6709 20.0007 10.6667C20.0007 9.6058 19.5792 8.58838 18.8291 7.83824C18.0789 7.08809 17.0615 6.66667 16.0007 6.66667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/Number 2.51475e762ba33e2b1a0d30276a499be0.svg";
export { ForwardRef as ReactComponent };